export default `content-feedback-question = War diese Übersetzung hilfreich?
content-feedback-reason = Warum war diese Übersetzung nicht hilfreich?
content-feedback-thanks = Vielen Dank für die Rückmeldung!

reference-toc-header = In diesem Artikel

footer-tagline = Dein Bauplan für ein besseres Internet.
footer-mofo = Besuche die gemeinnützige Muttergesellschaft der <a data-l10n-name="moco">Mozilla Corporation</a>, die <a data-l10n-name="mofo">Mozilla Foundation</a>.
footer-copyright = Teile dieses Inhalts sind ©1998–{ \$year } von einzelnen mozilla.org-Mitwirkenden. Inhalte sind verfügbar unter <a data-l10n-name="cc">einer Creative-Commons-Lizenz</a>.

search-modal-site-search = Erweiterte Suche nach <em>{ \$query }</em>

site-search-search-stats = { \$results } Dokumente gefunden.
site-search-suggestion-matches =  { \$relation ->
    [gt] mehr als { \$matches ->
        [one]   { \$matches } Übereinstimmung
       *[other] { \$matches } Übereinstimmungen
    }
   *[eq] { \$matches ->
        [one]   { \$matches } Übereinstimmung
       *[other] { \$matches } Übereinstimmungen
    }
}
site-search-suggestions-text = Meinten Sie:


theme-default = Systemstandard

blog-time-to-read = { \$minutes ->
    [one]   { \$minutes } Minute Lesezeit
   *[other] { \$minutes } Minuten Lesezeit
}
blog-post-not-found = Blogartikel nicht gefunden.

blog-previous = Voriger Artikel
blog-next = Nächster Artikel

No = Nein
Submit = Abschicken
Yes = Ja

obs-report = Report

obs-title = HTTP Observatory
obs-landing-intro = Seit 2016 verbessert HTTP Observatory die Sicherheit durch Analyse der Einhaltung bewährter Sicherheitspraktiken. Es hat durch 47 Millionen Scans Einblicke in über 6,9 Millionen Websites geliefert.
obs-assessment = Das von Mozilla entwickelte HTTP Observatory führt eine umfassende Bewertung der HTTP-Header und weiterer zentraler Sicherheitskonfigurationen einer Website durch.
obs-scanning = Der automatisierte Scan-Prozess liefert Entwicklern und Website-Administratoren detailliertes, handlungsorientiertes Feedback und konzentriert sich darauf, potenzielle Sicherheitslücken zu erkennen und zu beheben.
obs-security = Das Tool unterstützt Entwickler und Website-Administratoren maßgeblich dabei, ihre Websites in einem sich stetig weiterentwickelnden digitalen Umfeld gegen häufige Sicherheitsbedrohungen abzusichern.
obs-mdn = Das HTTP Observatory bietet wirksame Sicherheitseinblicke auf Grundlage von Mozillas Expertise und Engagement für ein sichereres Internet sowie basierend auf etablierten Trends und Richtlinien.
`;